module.exports = __webpack_public_path__ + "img/frame2.e2ebeaca.jpg";